import {useIntl} from 'react-intl'
import {MessageItemCommonProps} from '../../definitions'
import {Link} from 'react-router-dom'

type MessageItemReviewOrderProps = MessageItemCommonProps<string>
export const MessageItemReviewOrder = ({message}: MessageItemReviewOrderProps) => {
  const intl = useIntl()

  return (
    <div className='d-flex justify-content-between align-items-center py-4'>
      <div className='text-gray-600 '>{intl.formatMessage({id: 'REVIEW_ORDER_DETAIL'})}</div>
      <Link
        to={message.content}
        target='_blank'
        rel='noopener noreferrer'
        className='fw-bolder text-primary-200'
      >
        {intl.formatMessage({id: 'REVIEW'})}
      </Link>
    </div>
  )
}
